import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/services/api/apiRequest";

export type Policy = {
  slug: string;
  title: string;
  body: string;
  effectiveDate: string | null;
  updatedAt: string;
};

/** The Terms of Use or the Privacy Policy. Public: no token needed, and the
 * query must not be keyed on the viewer or a signed-out reader would be served
 * a signed-in reader's cached copy (they are the same document either way). */
export function usePolicy(slug: string) {
  return useQuery<Policy>({
    queryKey: ["afell", "policy", slug],
    queryFn: () => apiRequest(`/afell/policies/${slug}/`),
    staleTime: 5 * 60 * 1000,
  });
}

/** Soft Network's disclaimer for the resource listings. A policy row like the
 * other two, so a correction is made in /basement/ rather than by a release. */
export const RESOURCES_DISCLAIMER = "resources-disclaimer";
